import { AXIS_TYPE, BIND_TYPE, INCREMENT_TYPE, PERIOD_TYPE } from '@constants'
import { AutocompleteOption, ParameterDTO } from '@types'

export const enum OPERATION_TYPE {
  DELETE = 'DELETE',
  UPDATE = 'UPDATE',
  CREATE = 'CREATE',
}

export const enum COLUMN_OPERATION_TYPE {
  SUM = 'SUM',
  COUNT = 'COUNT',
}

export const columnOperations: AutocompleteOption[] = [
  {
    id: COLUMN_OPERATION_TYPE.SUM,
    label: 'Sum',
  },
  {
    id: COLUMN_OPERATION_TYPE.COUNT,
    label: 'Count',
  },
]

export const columnBindTypes: AutocompleteOption[] = [
  { id: BIND_TYPE.FIELD, label: 'Field' },
  { id: BIND_TYPE.JS, label: 'JS' },
]

export const enum OBJECT_TYPE {
  DIAGRAM = 'DIAGRAM',
  COLUMN = 'COLUMN',
  TIMELINE = 'TIMELINE',
  SERIES = 'SERIES',
  COLUMN_FIELD = 'COLUMN_FIELD',
  RESOURCE = 'RESOURCE',
}

export type DefaultRequestType = {
  operationType: OPERATION_TYPE
  type: OBJECT_TYPE
}

export type DiagramRequestType = DefaultRequestType & {
  data: {
    id?: number
    code: string
    title: string
  }
}

export type ColumnRequestType = DefaultRequestType & {
  data: {
    commandForEverySeries: boolean
    color: string
    jsFilterCreate: boolean
    command: any
    jsForAllFields: boolean
    jsCreateValue: string
    fields: ColumnFieldRequestType['data'][]
    id?: number
    code: string
    title: string
    operation: string
    diagramId: number
    prefilter: any // ?
    objectCode: string
    objectTitle: string
    order: number
    parameters: ParameterDTO[]
  }
}

export type TimelineRequestType = DefaultRequestType & {
  data: {
    id?: number
    diagramId?: number
    formatDate: string
    axisX: AXIS_TYPE
    period: PERIOD_TYPE
    timeIncrement: INCREMENT_TYPE
    hideFilters: boolean
    dateRange: {
      from: string
      till: string
    }
  }
}

export type SeriesRequestType = DefaultRequestType & {
  data: {
    id?: number
    timelineId?: number
    title: string
    order: number
    dateRange: {
      from: string
      till: string
    }
  }
}

export enum DIAGRAM_FIELD_BIND_TYPE {
  FIELD = 'field',
  JS = 'js',
  COMMAND = 'command',
}

export type ColumnFieldRequestType = DefaultRequestType & {
  data: {
    id?: number
    value: string
    bindType: DIAGRAM_FIELD_BIND_TYPE
    seriesId: number
    columnId: number
  }
}

export type ResourceRequestType = DefaultRequestType & {
  data: {
    id?: number
    diagramId?: number
    objectCode: string
    objectTitle: string
    viewId: number
    order: number
  }
}

type TimelineDataType = TimelineRequestType['data'] & {
  series: SeriesRequestType['data'][]
}

export type SelectedBar = {
  series: SeriesRequestType['data']
  column: ColumnRequestType['data']
  resource?: ResourceRequestType['data']
  timeIncrement: INCREMENT_TYPE
}

export type BarChartResponseType = {
  id: number
  internalId: string
  code: string
  title: string
  changed: boolean
  version?: string
  timeline: TimelineDataType
  columns: ColumnRequestType['data'][]
  resources: ResourceRequestType['data'][]
  hideFilters: boolean
  createdOn: string
  updatedOn?: string
}

export type BarChartRequestType = (
  | SeriesRequestType
  | TimelineRequestType
  | ColumnRequestType
  | DiagramRequestType
  | ColumnFieldRequestType
  | ResourceRequestType
)[]

export type CopyBarChartRequestType = {
  id: number
  code: string
  title: string
}
